var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mb-4"},[_c('div',{staticClass:"ml-3 mb-2"},[_c('span',{staticClass:"hyp-section-title application-heading",style:(_vm.styleTitle)},[_vm._v(_vm._s(_vm.titleModified))])]),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }